/**
 * THE WORDING A CLINICIAN OPENS ONTO, owned HERE rather than in `@astrana/ui`.
 *
 * The review of systems and the physical exam arrive pre-filled, one stated
 * normal per system. `@astrana/ui` ships a complete, usable set of those
 * sentences — but they are a library default, and the practice's vocabulary is
 * the practice's. Changing a sentence in the library means a library PR, a
 * release tag, a pin bump here and an extension rebuild. Changing it in this file
 * means editing this file.
 *
 * HOW TO CHANGE A DEFAULT: add or edit an entry below, keyed by the library's
 * system key. Anything not listed keeps the library's wording, so this file only
 * ever has to hold the differences. An unknown key is ignored and reported in the
 * console, naming the keys that exist — a typo does not silently do nothing.
 *
 * An empty string is a real instruction: it opens that row BLANK, and a blank row
 * contributes no text to the note at all.
 *
 * The keys, for reference (`DEFAULT_REVIEW_OF_SYSTEMS` / `DEFAULT_PHYSICAL_EXAM`):
 *
 *   review of systems  constitutional · eyes · ent · cardiovascular ·
 *                      respiratory · gastrointestinal · genitourinary ·
 *                      musculoskeletal · integumentary · neurological ·
 *                      psychiatric · endocrine · haematologic · allergic
 *   physical exam      general · heent · neck · cardiovascular · respiratory ·
 *                      abdomen · extremities · skin · neurological · psychiatric
 *
 * WHERE THIS IS HEADING: the durable home for this is the admin console, so a
 * practice can change its own wording without a deploy at all. That needs three
 * parts — an ungated drafting query in care-gql, a frontend consumer for it, and
 * this prop fed from the response (tracked as task 29). Until then, this file is
 * the seam, and it is deliberately the same shape the query will fill: swapping
 * a constant for fetched data changes nothing else.
 */
import type { ClinicalTemplateOverrides } from "@astrana/ui/scribe";

/**
 * Empty on purpose. The library's defaults are transcribed from this practice's
 * own Elation ROS checklist, so there is nothing to differ from yet — this exists
 * so that when there is, the change is one line here.
 */
export const VISIT_NOTE_TEMPLATE_OVERRIDES: ClinicalTemplateOverrides = {
  defaultFindings: {
    reviewOfSystems: {
      // e.g. eyes: "Denies visual changes or eye pain",
    },
    physicalExam: {
      // e.g. skin: "Warm, dry, intact",
    },
  },
};
